import { render, staticRenderFns } from "./BaseExitIcon.vue?vue&type=template&id=5ce53079&scoped=true"
import script from "./BaseExitIcon.vue?vue&type=script&lang=js"
export * from "./BaseExitIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce53079",
  null
  
)

export default component.exports